/// <amd-module name="Artifacts/Feed/containers/RootFeedHubRedirector" />

import { CreateFeedModalId } from "Artifacts/Feed/components/CreateFeedPanel";
import { ZeroFeeds } from "Artifacts/Feed/components/ZeroFeeds";
import { FeedModule } from "Artifacts/Feed/redux";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { RootActions } from "Artifacts/Root/redux/Actions";
import { feedHubRedirectorContainerName } from "Artifacts/Root/routing/Definitions";
import * as React from "react";
import { connect } from "react-redux";
import { Components } from "VSS/Platform/Layout";

const Actions = { hideModal: RootActions.hideModal, showModal: RootActions.showModal };

const RootFeedHubRedirector: React.FC<IRootFeedHubRedirectorMapStateToProps & typeof Actions> = ({
  hideModal,
  showModal,
}) => {
  // Ask server to redirect to a suitable feed based on permissions and most recently used feed
  const { resolution } = useFeed(true);

  return (
    <DefaultLoader state={resolution}>
      <div className="page-content page-content-top">
        <ZeroFeeds
          showCreateFeed={() =>
            showModal({ modalId: CreateFeedModalId, props: { onDismiss: hideModal } })
          }
        />
      </div>
    </DefaultLoader>
  );
};

interface IRootFeedHubRedirectorMapStateToProps {
  feedPickerState: ComponentState;
}

const ConnectedRootFeedHubRedirector = connectDynamicModules(
  connect(null, Actions)(RootFeedHubRedirector),
  FeedModule,
);

Components.add(feedHubRedirectorContainerName, ConnectedRootFeedHubRedirector);

export { ConnectedRootFeedHubRedirector as RootFeedHubRedirector };
